<template>
  <tooltip :position="position" :hideControls="hideControls">
    <div :class="$style.container">
      <innate :innate="innate" :hidden="isInnateHidden" />
    </div>
  </tooltip>
</template>

<script>
import Tooltip from './tooltip.vue'
import Innate from '../innate-details/innate.vue'

export default {
  name: 'innate-tooltip',
  components: { Tooltip, Innate },
  props: {
    hero: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: 'top'
    },
    preview: {
      type: Boolean,
      default: false
    },
    hideControls: {
      type: Boolean,
      default: false
    },
    innateOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    innate() {
      return this.getHeroAbilities(this.hero, 'innate')
    },
    abilities() {
      return this.getHeroAbilities(this.hero, 'abilities')
    },
    isInnateHidden() {
      const innateAbility = this.abilities.find((ability) => ability.name === this.innate)
      if (innateAbility) {
        return innateAbility.hidden
      }

      return true
    }
  }
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  width: 20.65vw;
  gap: 0.2vw;
}
</style>
